import * as load from 'audio-loader'

// Example coefficients for a low pass filter with F_c = 1000 Hz, from
// http://www.earlevel.com/main/2013/10/13/biquad-calculator-v2/.
const a0 = 0.00460399444634034
const a1 = 0.00920798889268068
const a2 = 0.00460399444634034
const b0 = 1
const b1 = -1.7990948352036205
const b2 = 0.8175108129889816
const DEFAULT_FEED_FORWARD = [a0, a1, a2]
const DEFAULT_FEED_BACK = [b0, b1, b2]

/**
 * An audio player that lets you change filter parameters, and also play
 * specific audio.
 */
export default class FilterPlayer {
  context: AudioContext
  filter: IIRFilterNode
  input: MediaStreamAudioSourceNode
  analyser: AnalyserNode
  gain: GainNode

  constructor() {
    let AudioContext = window.AudioContext || window.webkitAudioContext;
    this.context = new AudioContext()
    this.gain = this.context.createGain()
    this.gain.gain.value = 0.1
    this.analyser = this.context.createAnalyser()
    this.updateIIRFilter(DEFAULT_FEED_FORWARD, DEFAULT_FEED_BACK)
  }

  getAnalyser() {
    return this.analyser
  }

  play() {
    /*
    navigator.getUserMedia({audio: true},
      this.onStream.bind(this),
      this.onStreamError.bind(this));
     */

    //this.loadSound('assets/pinkgood.wav')
    this.loadSound('assets/whitenoise.wav')
    //this.loadSound('assets/techno.wav')
  }

  stop() {
    if (this.input) {
      this.input.stop(0)
    }
  }

  updateIIRFilter(feedforward, feedback) {
    if (this.filter) {
      this.filter.disconnect()
    }
    if (this.context.createIIRFilter) {
      this.filter = this.context.createIIRFilter(feedforward, feedback)
    } else {
      console.error('createIIRFilter not supported by this Web Audio API implementation.')
      this.filter = this.context.createGain()
    }

    // If there's a stream already playing, hook it up to the new filter.
    if (this.input) {
      this.connectInputToFilter()
    }
  }

  setGain(gain: number) {
    this.gain.gain.value = gain
  }

  private connectInputToFilter() {
    // Two paths:
    // input => filter => gain => destination (for playback)
    // input => filter => analyser (for analysis)
    this.input.connect(this.filter)
    this.filter.connect(this.gain)
    this.gain.connect(this.context.destination)
    // Also hook up the filter to the analyser.
    this.filter.connect(this.analyser)
  }

  private onStream(stream) {
    this.input = this.context.createMediaStreamSource(stream);

    this.connectInputToFilter()
  }

  private onStreamError(error) {
    console.error('Error getting microphone', error);
  }

  private loadSound(url) {
    load(url).then(buffer => {
      const source = this.context.createBufferSource()
      source.buffer = buffer
      source.loop = true
      source.start(0)
      this.input = source

      this.connectInputToFilter()
    })
  }
}



// WEBPACK FOOTER //
// ./src/FilterPlayer.ts